import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { LeadSourceClient, LeadSourceView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class LeadSourceService {
    constructor(private readonly client: LeadSourceClient) {}

    async getAll(): Promise<LeadSourceView[]> {
        return await lastValueFrom(this.client.leadSourceGetAll());
    }
}
